<template>
    <div class="breadcrumbs-contain breadcrumbs-contain-ad">


        <div class="breadcrumbs breadcrumbs-opportunityPC  breadcrumbsJia padRight-0 btnModify" style="margin-bottom:15px;" :class="{'breadcrumbs-pc':$store.state.innerWidth>768}">

            <span 
            class="breadcrumbs-item Medium" 
            v-for="(crumb,index) in crumbs" 
            :key="index" 
            v-on:click="clickBreadcrumbsFn(crumb.to,index)"
            :class="{'default':index==crumbs.length-1}"
            >

                <a href="javascript:;" style="color: inherit">{{crumb.isData?crumb.text: $t(("message."+crumb.text)) }}</a>
            </span>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            crumbs: []
        }
    },
    mounted() {
        this.clickBreadcrumbsFn=function(path,index) {
            if(index==this.crumbs.length-1) return;
            this.$router.push({ path: path , query:{lang:this.$store.state.language}});
        }
       
        this.crumbs = this.$route.meta.breadcrumbs
    }
}
</script>